import React from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { Link } from "react-router-dom";
import CircularProgress from '@material-ui/core/CircularProgress';
import Transition from 'react-transition-group/Transition';

const styles = theme => ({
    root: {
        textAlign: 'center',
    },
    title: {
        marginBottom: theme.spacing.unit * 2
    },
    projectContainer: {
        maxWidth: '1000px',
        padding: theme.spacing.unit,

        transition: 'all .5s',

        '&:hover': {
            transform: 'scale(1.1)',
            opacity: '.5'
          },
    },
    projectImage: {
    },
    projectTitle: {
        fontWeight: '300',
        color: 'black',
    },
    projectContent: {
        color: 'black'
    },
    projectContentContainer: {
        textAlign: 'left',

        [theme.breakpoints.up("sm")]: {
            width: '600px'
        },
        [theme.breakpoints.up("md")]: {
            width: '700px'
        },
        padding: theme.spacing.unit
    },
    progress: {
        marginTop: theme.spacing.unit * 6,
    },
    button: {
        margin: theme.spacing.unit
    },
    gridItem: {
        padding: theme.spacing.unit
    }
});


class Projects extends React.Component {

    state = {

        animate: false,
        mobile: false

    }

    componentDidMount() {
        window.addEventListener("resize", this.resize);
        this.resize();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize);
    }

    resize = () => {

        if (window.innerWidth > 820 && this.state.mobile === true) {

            this.setState({mobile: false});

        } else if (window.innerWidth < 820 && this.state.mobile === false) {

            this.setState({mobile: true});

        }

    }

    render() {

        const { classes, projects } = this.props;

        const duration = 500;

        const defaultStyle = {
          transition: `opacity ${duration}ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform ${duration}ms cubic-bezier(0.4, 0, 0.2, 1) 0ms`,
          opacity: 0,
          transform: 'scale(0)',
          willChange: 'transform'
        }
        
        const transitionStyles = {
          entering: { opacity: 0, transform: 'scale(0)' },
          entered:  { opacity: 1, transform: 'scale(1, 1)'},
        };


        if (projects) {
            return (
                <div className={classes.root}>
                    <Grid container direction="column" spacing={32} justify="center" alignItems="center">
                        {projects.map((p) => (
                            <Transition key={p.id} in={true} appear={true} timeout={100}>
                                {(state) => (
                                    <div style={{
                                    ...defaultStyle,
                                    ...transitionStyles[state],
                                    transitionDelay: ((p.id-1) * 125)+'ms'
                                    }}>
                                        <Grid item className={classes.gridItem}>
                                            {this.Project(p)}
                                        </Grid>
                                        
                                    </div>
                                )}
                            </Transition>
                        ))}
                    </Grid>
                </div>
            );
       } else {
           return (
                <CircularProgress size={100} color="secondary" className={classes.progress} />
           );
       }

    }

    PreviewImage = project => {
        const { classes } = this.props;
        return (

            <Grid item>      
                <img
                    src={project.images[0].link}
                    className={classes.projectImage}
                    style={{maxWidth: '200px', maxHeight: '250px'}}/>
            </Grid>
         
        );
    }

    ProjectContent = (project, position) => {
        
        const { classes } = this.props;
        if (this.state.mobile) {
            position = "center";
        }

        return (
            <Grid item>
                <Grid container direction="column" justify="center" alignItems={position} className={classes.projectContentContainer}>
                    <Grid item>
                        <Typography variant="h4" className={classes.projectTitle} align="center">
                            {project.title}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="body2" className={classes.projectContent} align="center">
                                {project.description}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Button variant="contained" color="secondary" className={classes.button} size="small" >
                            View More
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        );
    }

    Project = project => {

        const { classes } = this.props;

        if (!this.state.mobile) {
            return (
                <Grid container justify="center" alignItems="center" className={classes.projectContainer} component={Link} to={"/projects/"+project.projectId} style={{ textDecoration: 'none' }}>
                    {project.priority % 2 !== 0 && this.PreviewImage(project)}  {project.priority % 2 !== 0 && this.ProjectContent(project, "flex-end")}
                    {project.priority % 2 === 0 && this.ProjectContent(project, "flex-start")} {project.priority % 2 === 0 && this.PreviewImage(project)}
                </Grid>
            );
        } else {
            return (
                <Grid container direction="column" justify="center" alignItems="center" className={classes.projectContainer} component={Link} to={"/projects/"+project.projectId} style={{ textDecoration: 'none' }}>
                    {this.PreviewImage(project)}
                    {this.ProjectContent(project, "flex-start")}
                </Grid>
            );
        }
    }
}


export default withStyles(styles)(Projects);